import React, { useRef } from "react";
import { Button } from "reactstrap";

const FileUploader = ({
  onChange,
  value,
  className,
  title,
  style,
  icon = "bx bx-upload font-size-16 mx-1",
}: {
  onChange: (event: any) => void;
  value?: any;
  title?: string;
  className?: string;
  icon?: string;
  style?: any;
}) => {
  const hiddenFileInput = useRef(null);
  return (
    <React.Fragment>
      <div>
        <Button
          type="button"
          color="light"
          onClick={() => {
            //@ts-ignore
            hiddenFileInput.current.click();
          }}
          style={{
            color: "#666E7D",
            ...style,
          }}
          className={"btn " + className}
        >
          <i className={icon}></i>
          {title && (
            <span className="d-none d-sm-inline-block me-2">{title}</span>
          )}
        </Button>
        {value && <p>{value}</p>}
        <input
          id="image-uploader"
          multiple={false}
          type="file"
          style={{ display: "none" }}
          ref={hiddenFileInput}
          onChange={onChange}
        />
      </div>
    </React.Fragment>
  );
};
export default FileUploader;
